import { Card, CardProps } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { ParcelIcon, WarraingParcelIcon } from "icons";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 262,
      height: 157,
      borderRadius: "14px",
      WebkitBackdropFilter: "blur(45.1px)",
      backdropFilter: "lur(45.1px)",
      boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
      border: "solid 1px #f0f3f4",
      display: "flex",
    },
    smallLeft: {
      width: 10,
      backgroundColor: "#e3f8fa",
      zIndex: 1,
    },
    content: {
      display: "flex",
      flex: 1,
    },
    icon: {
      marginLeft: -15,
      marginTop: 10,
    },
  })
);
export interface OrderCardProps extends CardProps {
  height?: number | string;
  width?: number | string;
  variante?: "dashed" | "outlined";
  noBox?: boolean;
  warning?: boolean;
  isSelected?: boolean;
  leftBarreColor?: string
}
export function OrderCard({
  variante = "outlined",
  height = 148,
  width = 256,
  children,
  noBox,
  warning = false,
  isSelected = false,
  leftBarreColor = "#399ebf",
  ...props
}: OrderCardProps) {
  const styles = useStyles();
  const color = variante === "outlined" ? "#f0f3f4" : "#707070";
  return (
    <Card
      className={styles.root}
      style={{
        height,
        width,
        border: `${variante === "outlined" || isSelected ? "solid" : "dashed "} 1px ${isSelected ? "#399ebf" : color}`,
      }}
      {...props}
    >
      <div
        className={styles.smallLeft} 
        style={{
          visibility: variante === "outlined" ? "visible" : "hidden",
          backgroundColor: noBox ? `${warning ? "#FFE7E7" : leftBarreColor}` : warning ? "#FFE7E7" : "#e3f8fa",
          width: noBox ? 15 : 10,
        }}
      />
      <div
        className={styles.icon}
        style={{
          visibility: noBox ? "hidden" : "visible",
        }}
      >
        {warning ? <WarraingParcelIcon /> : <ParcelIcon color="#e3f8fa" />}
      </div>
      <div className={styles.content}>{children}</div>
    </Card>
  );
}

export default OrderCard;
